module.exports = __webpack_public_path__ + "img/kahovstanV2.8733f431.png";